// Колонки грида задач. Механика вида (порядок, скрытие, хранение на сервере)
// живёт в общем `shared/grid/useGridProfile` — здесь остался только состав
// колонок этой сущности.
import {
  useGridProfile,
  type GridColumnMeta,
  type GridProfile,
} from '../../../shared/grid/useGridProfile.js';
import { i18n } from '../../../i18n/index.js';

export const TASK_COLUMN_KEYS = [
  'title',
  'status',
  'priority',
  'dueAt',
  'assignee',
  'deal',
  'company',
  'contact',
  'createdAt',
] as const;

export type TaskColumnKey = (typeof TASK_COLUMN_KEYS)[number];

export const TASK_COLUMN_LABEL: Record<TaskColumnKey, string> = {
  get title() {
    return i18n.t('crm.features.columns.title');
  },
  get status() {
    return i18n.t('crm.features.columns.status');
  },
  get priority() {
    return i18n.t('crm.features.columns.priority');
  },
  get dueAt() {
    return i18n.t('crm.features.columns.due_at');
  },
  get assignee() {
    return i18n.t('crm.features.columns.assignee');
  },
  get deal() {
    return i18n.t('crm.features.columns.deal');
  },
  get company() {
    return i18n.t('crm.features.columns.company');
  },
  get contact() {
    return i18n.t('crm.features.columns.contact');
  },
  get createdAt() {
    return i18n.t('crm.features.columns.created_at');
  },
};

/** Колонки, скрытые по умолчанию (включаются в меню «Колонки»). */
const DEFAULT_HIDDEN: readonly TaskColumnKey[] = ['createdAt'];

export const TASK_GRID_COLUMNS: GridColumnMeta[] = TASK_COLUMN_KEYS.map((key) => ({
  key,
  get label() {
    return TASK_COLUMN_LABEL[key];
  },
  ...(DEFAULT_HIDDEN.includes(key) ? { hiddenByDefault: true } : {}),
}));

export function useTaskGridProfile(): GridProfile {
  return useGridProfile('tasks', TASK_GRID_COLUMNS);
}
